/**
 * @author Alejandro
 * @description Reduce the given play's list to an object with possession, offensive
 * and defensive lists.
 * @param {Array} playList - The play's list to filter
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {{possession: Array, offensive: Array, defensive: Array}}
 */
export function filterByCategoryType(playList, playValuesIndex) {
  return playList.reduce(
    (accumulator, play) => {
      switch (play[playValuesIndex.categoryType]) {
        // Possession
        case 1:
          accumulator.possession.push(play);
          break;
        //  Offensive
        case 2:
          accumulator.offensive.push(play);
          break;
        //  Defensive
        case 3:
          accumulator.defensive.push(play);
          break;
      }
      return accumulator;
    },
    {
      possession: [],
      offensive: [],
      defensive: [],
    },
  );
}

/**
 * @author Alejandro
 * @description Filter a play list by location and result
 * @param {Array} playList - The play list to filter
 * @param {Array<number>} selectedLocation - The selected location in filter component
 * @param {Array<number>} selectedResults - The selected results in filter component
 * @param {Array<number>} selectedGamesIds - The selected games
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @param {Number} teamId - Id analysis team
 * @param {Boolean} isLeague - avoid selectedGamesIds filter if is true
 * @return {Array} - The filtered play list
 */
export function filterByGameLocationsAndResults(
  playList,
  selectedLocation,
  selectedResults,
  selectedGamesIds,
  playValuesIndex,
  teamId,
  isLeague = false,
) {
  const selectedResultsRival = selectedResults.map(r => (r === 1 ? 2 : r === 2 ? 1 : 3));

  return playList.filter(play => {
    const isRivalPlay = teamId && play[playValuesIndex.teamId] ? play[playValuesIndex.teamId] !== teamId : false;
    const rivalPlayingAs = selectedLocation === 1 ? 2 : 1;

    return (
      (isLeague || selectedGamesIds.includes(play[playValuesIndex.gameId])) &&
      (!selectedLocation || (isRivalPlay ? rivalPlayingAs : selectedLocation) === play[playValuesIndex.playingAs]) &&
      ((selectedResults.includes(play[playValuesIndex.matchResult]) && play[playValuesIndex.teamId] === teamId) ||
        (selectedResultsRival.includes(play[playValuesIndex.matchResult]) && play[playValuesIndex.teamId] !== teamId))
    );
  });
}

/**
 * @author Alejandro
 * @description Filter a play list by location and result
 * @param {Array} playList - The play list to filter
 * @param {Array<number>} playingAs - Playing as home team or visiting team or both
 * @param {Array<number>} selectedResults - The game result, win, loss, draw or all of three
 * @param {Array<number>} selectedSections - The selected time sections
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {Array} - The filtered play list
 */
export function filterByGameLocationsResultsAndSections(
  playList,
  playingAs,
  selectedResults,
  selectedSections,
  playValuesIndex,
) {
  // Check if all options are selected to avoid filter iteration
  if (playingAs.length === 2 && selectedResults.length === 3 && selectedSections.length === 6) {
    return playList;
  }
  return playList.filter(play => {
    return (
      playingAs.includes(play[playValuesIndex.playingAs]) &&
      selectedResults.includes(play[playValuesIndex.matchResult]) &&
      selectedSections.includes(play[playValuesIndex.section])
    );
  });
}
